import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Datatable extends Component {
  render() {
    const { myData } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="sp-table-wrap">
          <table className="table sp-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Note</th>
                <th scope="col">Amount</th>
                <th scope="col" className="sp-col-action">Receipt</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className="sp-empty">
                    <EmptyState>No entries for this month.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{expense.date}</td>
                    <td>{expense.note}</td>
                    <td>
                      <span className="sp-amount-pill">{expense.amount}Tk</span>
                    </td>
                    <td className="sp-col-action">
                      {expense.imageUrl ? (
                        <a href={expense.imageUrl} target="_blank" rel="noreferrer">
                          <img
                            src={expense.imageUrl}
                            alt="receipt"
                            style={{
                              minHeight: 44,
                              maxHeight: 44,
                              minWidth: 40,
                              maxWidth: 40,
                              objectFit: "cover",
                              borderRadius: 8,
                              border: "1px solid var(--sp-border)",
                            }}
                          />
                        </a>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
